<template>
  <v-layout align-center justify-center row class="mb-12">
    <v-flex xs12 sm10 md6 text-center>
      <div>
        <h1>ประเภทพัสดุ</h1>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12" v-for="(parcelType, index) in parcelTypes" :key="index">
              <v-card align="left" @click="goto(parcelType.PT_ID,parcelType.PT_THNAME)">
                <v-row>
                  <v-col cols="4" align="center">
                    <v-icon color="blue" x-large v-if="parcelType.PT_CATEGORY === 'Envelope'">
                      mdi-email
                    </v-icon>
                    <v-icon color="blue" x-large v-if="parcelType.PT_CATEGORY === 'Package'">
                      mdi-file
                    </v-icon>
                    <v-icon color="blue" x-large v-if="parcelType.PT_CATEGORY === 'Box'">
                      mdi-package-variant-closed
                    </v-icon>
                    <v-icon color="blue" x-large v-if="parcelType.PT_CATEGORY === 'Other'">
                      mdi-briefcase-clock-outline
                    </v-icon>
                  </v-col>
                  <v-col>
                    <v-card-title>{{ parcelType.PT_THNAME }}</v-card-title>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "@/axios";
import EventBus from '@/EventBus'

export default {
  name: "Step4",
  data() {
    return {
      parcelTypes: {}
    }
  },
  mounted() {
    this.getParcelType()
  },
  methods: {
    goto(id, name) {
      let params = {
        id: id,
        name: name,
        step: 4
      }
      EventBus.$emit('step_submit', params)
    },
    async getParcelType() {
      try {
        axios.get("/GetParcelType").then((res) => {
          // console.log('GetParcelType',res.data.data)
          this.parcelTypes = res.data.data
        });
      } catch (err) {
        console.log("GetParcelType", err.message);
      }
    }
  }
}
</script>

<style scoped>

</style>